import React from "react";
import style from "../dashboard.module.scss";
import continueCodingPlaying from "../../../../../assets/dashboardImages/continueCodingPlaying.png";
export const CallToActionBox = () => {
  return (
    <div className={style.ctaBox}>
      <img width="80px" src={continueCodingPlaying} alt="Duyurular İkonu" />
      <p className={style.ctaText}>Kodlamaya ve Oynamaya Devam Et!</p>
      <img width="80px" src={continueCodingPlaying} alt="Duyurular İkonu" />
    </div>
  );
};
